import { Emitter } from '@mnasyrov/pubsub';
const emitter = new Emitter();
export function getEmitter() {
    return emitter;
}
export function broadcast() {
    emitter.emit(1);
}
